import React, { useCallback, useMemo, useState } from 'react';
import { Layout } from '@oneaudi/unified-web-components';
import { useTranslation } from 'react-i18next';
import { TagLabel } from '../Common/Common.styles';
import OffersTag from '../../assets/icons/OffersTag';
import InfoIcon from '../../assets/icons/InfoIcon';
import { BonusCTA } from './EmblaCarousel.styles';
import { PromotionType } from '../../types/offers';
import Modal from '../Modal';
import useCtaUrls from '../../hooks/useCtaUrls';

type OfferTypesTagsProps = {
  offer: PromotionType;
  dealerId?: string;
};

const OfferTypeTags: React.FC<OfferTypesTagsProps> = ({ offer, dealerId }) => {
  const { t } = useTranslation();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isStackableOffers, setIsStackableOffer] = useState(false);

  const { stackableOffers, offerType } = offer;

  const inventoryUrl = useCtaUrls(offer);

  const hasAnyStackableOffers = stackableOffers.length > 0;

  const handleOpenModal = useCallback((event: React.MouseEvent<HTMLButtonElement>) => {
    const buttonId = event.currentTarget.id;
    if (buttonId === 'bonus-offer') setIsStackableOffer(true);
    setIsModalOpen(true);
  }, []);

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setIsStackableOffer(false);
  };

  const offerTag = useMemo(() => {
    return (
      <TagLabel data-testid={`${offerType}-tag`}>
        {t(`promo.tile.offerType.${offerType}`)} Offer
      </TagLabel>
    );
  }, [offerType, t]);

  const bonusOfferTag = useMemo(() => {
    return (
      <BonusCTA type="button" onClick={handleOpenModal} id="bonus-offer">
        <Layout align="center" columnGap="xs">
          <div>
            <TagLabel className="tag-label" data-testid={`${offerType}-tag`}>
              <OffersTag size="small" />
              {t(`promo.offers.viewEligibleBonusOfferCta`)}
            </TagLabel>
          </div>
          <InfoIcon />
        </Layout>
      </BonusCTA>
    );
  }, [handleOpenModal, offerType, t]);

  return (
    <Layout columnGap="s">
      {offerTag}
      {hasAnyStackableOffers && bonusOfferTag}
      {isModalOpen && (
        <Modal
          offer={offer}
          inventoryUrl={inventoryUrl}
          onCloseModal={handleCloseModal}
          dealerId={dealerId}
          isStackableOffers={isStackableOffers}
        />
      )}
    </Layout>
  );
};

export default OfferTypeTags;
